import { Tutor } from '@/store/tutors/types'
import { Pager } from '@/store/pager.types'
import { Moment } from 'moment'
import { Student } from '../students/types'

export const ApplicationType = {
  vacation: 'Absence Day',
  booth: 'Booth',
  workOvertime: 'Work on day with no classes',
  spir: 'Student Placement Irregularity Report',
  inquiry: 'Inquiry',
}
export type applicationTypeCode = keyof typeof ApplicationType

// 申請ステータス
export const ApplicationStatus = {
  approved: 'Approved',
  rejected: 'Rejected',
  cancelled: 'Cancelled',
  unapproved: 'Unapproved',
  withdrew: 'Withdrawn',
}
export type applicationStatusCode = keyof typeof ApplicationStatus

export interface ApplicationsState {
  applications: Application[];
  pager: Pager;
}

/**
 * 申請共通フォーマット
 */
export interface Application {
  id?: string
  type: applicationTypeCode
  student?: {
    id: string,
    studentNumber?: string,
    name: string
    nameEn?: string
  } | Student
  status?: applicationStatusCode
  // 申請者
  applicant?: {
    id: string // 申請チューターID or 管理者ID
    name: string
  }
  // 申請日
  applicationDate?: Moment
  // 承認取消者
  // authorizer?: Tutor
  approvedComment?: string
}

/**
 * 申請一覧検索条件
 */
export interface ApplicationSearchConditions {
  targetTutor: Tutor|null,
  types: applicationTypeCode[],
  statuses: applicationStatusCode[],
  from: Moment|null
  to: Moment|null
}

/**
 * 申請取り下げ
 */
export interface WithdrawApplication {
  applicationId: string
  comment: string
}
